<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main class="app-main">
      <router-view />
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>
<script>
export default {
  components: {}
};
</script>
<style scoped>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-main {
  flex: 1 0 auto;
}
</style>
